import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SupplierCodeOfConduct from "@/pages/SupplierCodeOfConduct";

export const Route = createFileRoute("/zh-cn/supplier-code-of-conduct")({
  head: () => buildRouteHead("/zh-cn/supplier-code-of-conduct"),
  component: SupplierCodeOfConduct,
});

